import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext } from 'react';
import { useAnalyticsId } from '~/context/vdp/SectionAnalyticsContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';

export default function useSpinnerWithAnalytics() {
  const analyticsId = useAnalyticsId();
  const { trackEvent } = useContext(AnalyticsContext);
  const { hasError, isSpinnerDisabled, openSpinnerView360 } =
    useContext(SpinnerContext);
  const isWIPVehicle = useGetIsWIPVehicle();
  const canClickImage = !hasError && !isSpinnerDisabled && !isWIPVehicle;

  const triggerSpinner = useCallback(
    (action: string) => {
      if (!canClickImage) return;

      openSpinnerView360();

      if (analyticsId) {
        trackEvent(analyticsId, {
          action,
          description: 'hero image'
        });
      }
    },
    [analyticsId, canClickImage, openSpinnerView360, trackEvent]
  );

  return { triggerSpinner, canClickImage };
}
